export default "__VITE_ASSET__Ca0M5715__"